import * as types from './mutation-types'
import controllers from '../../services/controllers'
import { createServiceCall } from '../actionsUtil'

export const getControllers = createServiceCall({
  mainAction: types.GET_CONTROLLERS_REQUEST,
  serviceFunction: controllers.getControllers,
  successAction: types.GET_CONTROLLERS_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_CONTROLLERS_FAILURE
})
